function hasError(response) {
  return response && Object.hasOwnProperty.call(response, 'error');
}

export { hasError };
